module.exports = __webpack_public_path__ + "static/media/meter-gas.4e102917.svg";